import { throttle } from 'throttle-debounce'

let Menu =
{
	headerEl: document.querySelector('body > header'),
	mainMenuEl: document.querySelector('.menu--main__wrapper'),
	currentMenu: null,
	currentOption: null,

	init: () => {
		if (document.querySelector('.menu--main')) {
			window.addEventListener('scroll', throttle(100, true, Menu.doSticky, true));
			setTimeout(() => Menu.doSticky(true), 200);

			Menu.doMegamenu();
			Menu.doMobile();
		}
	},

	doSticky: (ignoredistance) => {
		let distanceY = window.pageYOffset || document.documentElement.scrollTop,
			_scrollShrinkOn = 60;

		if (ignoredistance !== true && distanceY > 200) return;

		if (distanceY > _scrollShrinkOn && !Menu.headerEl.classList.contains('minheader')) {
			Menu.headerEl.classList.add('minheader');
		} else if (distanceY < _scrollShrinkOn) {
			Menu.headerEl.classList.remove('minheader');
		}
		// Menu.headerEl.classList.toggle('minheader', distanceY > _scrollShrinkOn);
	},

	doMegamenu: () => {
		//  Click to open
		live('click', '.menu--main a.has-children', function (e) {
			e.preventDefault();

			let parentLi = this.parentNode;
			if (parentLi.classList.contains('is-open')) {
				parentLi.classList.remove('is-open');
				document.querySelector('html').classList.remove('overlay');

				Menu.currentMenu = Menu.currentOption = null;

			} else {
				parentLi.classList.add('is-open');
				if (Menu.currentMenu) {
					Menu.currentMenu.classList.remove('is-open');
				}
				Menu.currentMenu = parentLi;

				document.querySelector('html').classList.add('overlay');
			}

		});

		//  Listen for ESC key
		window.addEventListener('keydown', function (event) {
			let el = document.querySelector('.menu--main > li.is-open');
			if (el && event.key === 'Escape') {
				el.classList.remove('is-open');
				document.querySelector('html').classList.remove('overlay');

				Menu.currentMenu = Menu.currentOption = null;
			}
		});

		//	Click outside of panel
		window.addEventListener('click', function (e) {
			let el = document.querySelector('.menu--main .is-open .menu--main__submenu');
			if (el && e.clientY > (el.getBoundingClientRect().top + el.getBoundingClientRect().height)) {
				document.querySelector('.menu--main .is-open').classList.remove('is-open');
				document.querySelector('html').classList.remove('overlay');

				Menu.currentMenu = Menu.currentOption = null;
			}
		})
	},

	doMobile: () => {
		// Mobile slide menu
		require('./components/waslidemenu');
		require('./components/selectnav');

		// SelectNav menu
		selectnav('.menu--side', {
			label: '- izberite -',
		});

		// Check for media query and start / destroy waSlideMenu
		enquire.register('screen and (min-width:768px)', {
			match: function () {
				if ($('.menu--main__inner').hasClass('waSlideMenu-nav')) {
					$('.menu--main__inner').waSlideMenu('exec','destroy');

					// Moving submenu's UL into div
					for (var elm of document.querySelectorAll('.menu--main .has-children + ul')) {
						elm.parentNode.querySelector('.menu--main--sub').appendChild(elm);
					}
				}
				document.querySelector('header').classList.remove('menu-open');
			}
		});
		enquire.register('screen and (max-width:767px)', {
			match: function () {

				// Moving submenu's UL into directly nested menu
				for (var elm of document.querySelectorAll('.menu--main .has-children')) {
					elm.after(elm.parentNode.querySelector('ul'));
				}



				$('.menu--main__inner').waSlideMenu({
					autoHeightMenu: false,
					backOnTop: true,
					scrollToTopSpeed: 200,
					slideSpeed: 200,
					backLinkContent: '<svg class="ticon"><use xlink:href="/media/dsg/icons.svg?#icon-angle"></use></svg> Nazaj',
					onLatestClick: function(){
						location.href = $(this).attr('href');
					}
				});


			}
		});

		// Mobile menu trigger
		document.querySelector('.trigger-mobile').addEventListener('click', (e) => {
			e.preventDefault();

			var menuHeight = 0;

			if (Menu.headerEl.classList.contains('menu-open')) {
				Menu.headerEl.classList.remove('menu-open');
				Menu.currentOption = null;
				// alert('1: ' + $('.waSlideMenu-menu').outerHeight()); ĆE SE ZAPRE
			} else {
				Menu.headerEl.classList.add('menu-open');
				Menu.currentOption = 'menu';
				menuHeight = $('.waSlideMenu-menu').outerHeight();
				$('.menu--main .has-children + ul').height(menuHeight);
			}

		});

		// Mobile search
		// document.querySelector('.trigger-search').addEventListener('click', function (e) {
		// 	e.preventDefault();
		// 	el.classList.toggle('is-shown');
		// })

		// Mobile user

	}

}
Menu.init();
